<template>
  <div>
    <Header></Header>
    <div class="legal-content">
     

      <h2>{{ $t("legal_n_1") }}</h2>
      <br />
      <p>{{ $t("legal_n_2") }}</p>
      <br />
      <p>{{ $t("legal_n_3") }}</p>
      <br />
      <p>{{ $t("legal_n_4") }}</p>
      <br />
      <p>{{ $t("legal_n_5") }}</p>
      <p>{{ $t("legal_n_6") }}</p>
      <br />
      <p>{{ $t("legal_n_7") }}</p>
      <br />
      <p>{{ $t("legal_n_8") }}</p>
      <p>{{ $t("legal_n_9") }}</p>
      <p>{{ $t("legal_n_10") }}</p>
      <br />
      <p>{{ $t("legal_n_11") }}</p>
      <br />
      <p>{{ $t("legal_n_12") }}</p>
      <p>{{ $t("legal_n_13") }}</p>
       <br />
      <p>{{ $t("legal_n_14") }}</p>
      <p>{{ $t("legal_n_15") }}</p>
      <br />
      <p>{{ $t("legal_n_16") }}</p>
      <br />
      <p>{{ $t("legal_n_17") }}</p>
      <br />
      <p>{{ $t("legal_n_18") }}</p>
      <br />
      <h5>{{ $t("legal_n_19") }}</h5>
      <p>{{ $t("legal_n_20") }}</p>
      <br />
      <p>{{ $t("legal_n_21") }}</p>
      <br />
      <p>{{ $t("legal_n_22") }}</p>
      <br />
      <h5>{{ $t("legal_n_23") }}</h5>
      <p>{{ $t("legal_n_24") }}</p>
      <br />
      <p>{{ $t("legal_n_25") }}</p>
      <br />
      <p>{{ $t("legal_n_26") }}</p>
      <br />
      <h5>{{ $t("legal_n_27") }}</h5>
      <p>{{ $t("legal_n_28") }}</p>
      <br />
      <h5>{{ $t("legal_n_29") }}</h5>
      <p>{{ $t("legal_n_30") }}</p>
      <br />
  
    </div>
    <Footer></Footer>
  </div>
</template>

<script>
export default {};
</script>

<style lang="scss" scoped>
.legal-content {
  margin: -40px 138px 80px 138px;
  padding: 50px 50px 40px 60px;

  text-align: left;
  background: rgb(194 191 186 / 10%);
  color: #000;

  /* 移动端 */
  @media (max-width: 767px) {
    margin: 0px;
    padding: 50px 20px 24px 20px;

    .legalTitle {
      font-size: 18px;
      text-align: left;
    }
  }

  /* 整体p字体样式 */
  p {
    font-size: 16px;
    line-height: 28.5px;

    &.last-update {
      font-size: 16px;
      margin-bottom: 0;

      & + p {
        margin-top: 0;
      }
    }

    &.title,
    &.sub-title {
      font-size: 20px;
      font-weight: bold;
      margin-bottom: 0;

      & + p {
        margin-top: 0;
      }
    }

    &.sub-title {
      font-size: 14px;
    }
  }

  h2 {
    font-size: 18px;
    text-align: center;
    font-family: NexaBold;
    @media (max-width: 767px) {
      font-size: 20px;
      text-align: left;
    }
  }

  h6 {
    font-size: 19px;
    margin: 36px 0;
    font-family: NexaBold;
  }

  h5 {
    font-size: 18px;
    margin: 33px 0;
    font-family: NexaBold;
  }
}
</style>
